const actionBase = 'DASHBOARD_TENANTS'
const STATE = {
  tenants: null,
  errMsg: null,
  sucMsg: null,
  loading: false,
}

export function tenants(action){

  switch (action.type) {

    // On Pending
    case `${actionBase}_LOAD_REQUEST`:
      return {...STATE, loading: true}

    // On success request
    case `${actionBase}_LOAD_SUCCESS`:
      return {
        ...STATE,
        tenants: action.payload.tenants,
        loading: false
      }

    // On failed request
    case `${actionBase}_LOAD_FAILURE`:
      return {
        ...STATE,
        errMsg: action.payload,
        loading: false
      }

    default:
      return STATE

  }

}
